import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    defaultMessage:
      'Need your Ethereum main network assets on {networkName}? Please visit {bridge}',
  },
});
